@if (diagnostic(); as diagnostic) {
    <app-partner-header [diagnosticDate]="diagnosticDate()"></app-partner-header>
    <div class="m-auto flex flex-col gap-y-5 px-[8vw] pb-6 pt-12 md:px-6">
        @if (!partnerTheme()) {
            <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
        }
        <app-restaurant-information [diagnostic]="diagnostic"></app-restaurant-information>
        <ng-container [ngTemplateOutlet]="scoreTemplate" [ngTemplateOutletContext]="{ diagnostic }"></ng-container>
        @if (diagnostic.inconsistencies) {
            <app-diagnostic-inconsistencies [diagnostic]="diagnostic"></app-diagnostic-inconsistencies>
        }
        <app-restaurant-diagnostic-keywords
            [keywords]="mappedKeywords()"
            [diagnosticData]="{
                diagnostic: diagnostic,
                receiverEmail: receiverEmail() ?? '',
            }"></app-restaurant-diagnostic-keywords>
        @if (!partnerTheme()) {
            <ng-container [ngTemplateOutlet]="speakToAnExpertTemplate"></ng-container>
        }
        <app-diagnostic-competitors [diagnostic]="diagnostic"></app-diagnostic-competitors>
        <app-semantic-analysis
            [diagnostic]="diagnostic"
            [locale]="locale"
            [isMalouRestaurant]="isMalouRestaurant()"
            (talkToAnExpert)="talkToAnExpert()"></app-semantic-analysis>
        @if (doesRestaurantHasInstagramData()) {
            <ng-container [ngTemplateOutlet]="instagramCompetitorsTemplate"></ng-container>
        }
        @if (doesRestaurantHasFacebookData()) {
            <ng-container [ngTemplateOutlet]="facebookCompetitorsTemplate"></ng-container>
        }
        @if (!partnerTheme()) {
            <ng-container [ngTemplateOutlet]="talkToAnExpertFooterTemplate"></ng-container>
        }
    </div>
}

<ng-template #headerTemplate>
    <div>
        <div class="flex justify-between">
            <div class="flex">
                <div
                    class="malou-text-34--bold md:malou-text-28--bold font-passion-one uppercase text-malou-text-title md:leading-none"
                    [innerHTML]="'maloupe.diagnostic_result.header' | translate"></div>
                <mat-icon
                    class="relative bottom-2.5 right-3 !h-10 !w-10 shrink-0 text-malou-pink md:!hidden"
                    [svgIcon]="SvgIcon.SPARKLES"></mat-icon>
            </div>
            @if (isMalouUser() && publicDiagnosticUrl()) {
                <button
                    class="flex !h-12 !w-16 items-center justify-center rounded-full !text-malou-white sm:!h-10 sm:!w-20"
                    mat-flat-button
                    [ngClass]="{
                        'bg-malou-primary': !isLinkCopied(),
                        'bg-malou-primary--light': isLinkCopied(),
                    }"
                    (click)="copyLink()">
                    <mat-icon [svgIcon]="isLinkCopied() ? SvgIcon.CHECK : SvgIcon.LINK"></mat-icon>
                </button>
            }
        </div>

        <div class="malou-text-28--medium md:malou-text-14--medium text-malou-text md:mt-1">
            {{ diagnosticDate() | sentenceCase }}
        </div>
    </div>
</ng-template>

<ng-template let-diagnostic="diagnostic" #scoreTemplate>
    <app-diagnostic-score [diagnostic]="diagnostic" [isPreview]="false"></app-diagnostic-score>
</ng-template>

<ng-template #speakToAnExpertTemplate>
    <div class="flex items-center justify-between rounded-[10px] bg-malou-blue p-8 md:flex-col">
        <div class="flex flex-col p-5 md:gap-2 md:px-0">
            <div
                class="malou-text-35--regular font-passion-one uppercase text-white md:leading-tight"
                [innerHTML]="'maloupe.diagnostic_result.talk_to_an_expert.title_1' | translate"></div>
            <div class="malou-text-18--regular text-white">
                {{ 'maloupe.diagnostic_result.talk_to_an_expert.text_1' | translate }}
            </div>
        </div>
        <button
            class="malou-text-16--regular h-12.5 w-[220px] rounded-full px-6 py-3 text-center gradient-bg-primary md:w-full"
            (click)="talkToAnExpert()">
            {{ 'maloupe.diagnostic_result.talk_to_an_expert.cta' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #instagramCompetitorsTemplate>
    <div
        class="p-8 pl-14 md:p-6"
        [ngClass]="
            partnerTheme() ? 'rounded-[5px] border border-[#eeede9] bg-white' : 'rounded-[10px] border border-malou-primary bg-malou-white'
        ">
        <app-social-network-diagnostic-result
            platformKey="instagram"
            [socialPage]="instagramPage()"
            [socialPageDiagnosticRating]="instagramDiagnosticRating()">
        </app-social-network-diagnostic-result>
        <div
            class="mt-4 flex items-center gap-4 md:gap-3 md:px-3"
            [ngClass]="partnerTheme() ? 'rounded-[5px] bg-[#eeede9] px-8 py-3' : 'rounded-xl bg-malou-dark px-8 py-5'">
            <img class="w-[50px] sm:!h-8 md:h-fit md:w-9" [alt]="Icon.TRUMPET" [src]="Icon.TRUMPET | imagePathResolver" />
            <div
                [ngClass]="partnerTheme() ? 'malou-text-12--bold text-malou-text-title' : 'malou-text-12--regular'"
                [innerHTML]="'maloupe.diagnostic_result.instagram.indication' | translate"></div>
        </div>
    </div>
</ng-template>

<ng-template #facebookCompetitorsTemplate>
    <div
        class="p-8 pl-14 md:p-6"
        [ngClass]="
            partnerTheme() ? 'rounded-[5px] border border-[#eeede9] bg-white' : 'rounded-[10px] border border-malou-primary bg-malou-white'
        ">
        <app-social-network-diagnostic-result
            platformKey="facebook"
            [socialPage]="facebookPage()"
            [socialPageDiagnosticRating]="facebookDiagnosticRating()">
        </app-social-network-diagnostic-result>
    </div>
</ng-template>

<ng-template #talkToAnExpertFooterTemplate>
    <div class="flex rounded-[10px] bg-malou-blue p-12 pb-6 md:flex-col md:gap-4 md:overflow-hidden md:p-6 md:pb-0">
        <div class="flex w-[60%] flex-col md:w-full">
            <div
                class="malou-text-50--regular md:malou-text-34--regular font-passion-one uppercase text-white md:leading-none"
                [innerHTML]="'maloupe.diagnostic_result.talk_to_an_expert.title_2' | translate"></div>
            <div class="malou-text-18--regular mb-8 mt-6 text-white">
                {{ 'maloupe.diagnostic_result.talk_to_an_expert.text_2' | translate }}
            </div>
            <button
                class="malou-text-16--regular h-12.5 w-fit rounded-full px-6 py-3 text-center gradient-bg-primary md:w-full"
                (click)="talkToAnExpert()">
                {{ 'maloupe.diagnostic_result.talk_to_an_expert.cta' | translate }}
            </button>
        </div>
        <div class="md:h-content w-[40%] md:relative md:w-full">
            <!-- Trick to have the right div height, and use position absolute for the image to be displayed on the right -->
            <img class="invisible hidden md:block" [src]="Illustration.FINGER_BEST_FOOD_IN_TOWN | illustrationPathResolver" />
            <img class="md:absolute md:right-[-60px] md:top-0" [src]="Illustration.FINGER_BEST_FOOD_IN_TOWN | illustrationPathResolver" />
        </div>
    </div>
</ng-template>
